import * as squint_core from 'squint-cljs/core.js';
import { h, render } from 'preact';
import * as dom from './cljdoc.client.dom.jsx';
import * as cljdoc_DOT_client_DOT_dom from './cljdoc.client.dom.jsx';
var onsubmit = function (e) {
e.preventDefault();
const form_1 = document.getElementById("cljdoc-navigator");
const project_2 = (() => {
const G__11365_3 = form_1.querySelector("[name=project]");
if ((G__11365_3 == null)) {
return null} else {
return G__11365_3.value};

})();
const version_4 = (() => {
const G__11366_5 = form_1.querySelector("[name=version]");
if ((G__11366_5 == null)) {
return null} else {
return G__11366_5.value};

})();
if (squint_core.truth_(((squint_core.truth_(project_2)) ? ((project_2.length > 0)) : (project_2)))) {
return window.location.href = ((squint_core.truth_(project_2.includes("/"))) ? (`${"/d/"}${project_2??''}${"/"}${version_4??''}`) : (`${"/d/"}${project_2??''}${"/"}${project_2??''}${"/"}${version_4??''}`));
};

};
var form_field = function (p__11367) {
const map___1_3 = p__11367;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const name_5 = squint_core.get(map___1_4, "name");
const label_6 = squint_core.get(map___1_4, "label");
const tip_7 = squint_core.get(map___1_4, "tip");
const placeholder_8 = squint_core.get(map___1_4, "placeholder");
return <fieldset class="fl w-50-ns pa2 bn mh0"><label class="b db mb3">{label_6}<span class="normal ml2 gray f6">{tip_7}</span></label><input name={name_5} class="w-90 pa2 b--blue br2 ba no-outline" auto-correct="off" autocapitalize="none" placeholder={placeholder_8}></input></fieldset>;

};
var Navigator = function () {
return <><form id="cljdoc-navigator" onsubmit={onsubmit}><div><div class="cf nl2 nr2">{form_field(({"name": "project", "label": "Group ID / Artifact ID", "tip": "may be identical", "placeholder": "e.g. 're-frame' or 'ring/ring-core"}))}{form_field(({"name": "version", "label": "Version", "tip": "optional", "placeholder": "e.g. '1.0.2'"}))}</div><input class="bg-blue white bn pv2 ph3 br2" type="submit" value="Go to Documentation"></input></div></form></>;

};
var init = function () {
const temp__6897__auto___1 = dom.query("[data-id='cljdoc-js--cljdoc-navigator']");
if (squint_core.truth_(temp__6897__auto___1)) {
const navigator_node_2 = temp__6897__auto___1;
return render(h(Navigator), navigator_node_2);
};

};

export { init, onsubmit }
